<template>
	<router-link :to="family && (link === undefined ? true : link) ? '/family/' + family.id : '#'">
		<img alt="" :src="image || (family ? family.avatar : undefined) || '/network/static/img/default_family.jpg'" class="avatar" :title="family && family.name"> <span v-if="showName">{{ family && family.name }}</span>
	</router-link>
</template>

<script>
module.exports = {
	name: 'c-avatar',
	props: ['family', 'image', 'showName', 'link']
};
</script>



// WEBPACK FOOTER //
// c-avatar.vue?61ce36a6